module.exports = __webpack_public_path__ + "img/ic-log-in.bf9249ca.svg";